const pad = (n) => String(n).padStart(2, '0');

/** Date -> value for <input type="datetime-local"> ("YYYY-MM-DDTHH:mm", local time). */
export const toLocalInput = (date) =>
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;

/**
 * Backend string -> Date. The current backend stores dates as plain strings, written by the
 * legacy UI as "yyyy-MM-dd HH:mm:ss+05:30". Returns null when unparseable.
 */
export const parseBackendDate = (value) => {
  if (!value) return null;
  const d = new Date(String(value).replace(' ', 'T'));
  return Number.isNaN(d.getTime()) ? null : d;
};

/** <input type="datetime-local"> value -> "yyyy-MM-dd HH:mm:ss+HH:MM" (same shape the legacy UI sent). */
export const toBackendDateTime = (localInput) => {
  const d = new Date(localInput);
  if (Number.isNaN(d.getTime())) return null;
  const offsetMin = -d.getTimezoneOffset();
  const sign = offsetMin >= 0 ? '+' : '-';
  const abs = Math.abs(offsetMin);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}${sign}${pad(Math.floor(abs / 60))}:${pad(abs % 60)}`;
};

export const addDays = (date, days) => new Date(date.getTime() + days * 24 * 60 * 60 * 1000);

/** Round a date UP to the next multiple of `stepMinutes` (seconds and milliseconds dropped). */
export const roundUpToStep = (date, stepMinutes = 15) => {
  const step = stepMinutes * 60 * 1000;
  return new Date(Math.ceil(date.getTime() / step) * step);
};

/**
 * The browser's time zone, for display next to the pickers, e.g. "Asia/Calcutta (UTC+05:30)". The picker works in
 * this zone, and the saved value carries its offset, so the same instant is stored whatever zone the user is in.
 */
export const timeZoneLabel = (date = new Date()) => {
  let zone = '';
  try { zone = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) { zone = ''; }
  const offsetMin = -date.getTimezoneOffset();
  const abs = Math.abs(offsetMin);
  const offset = `UTC${offsetMin >= 0 ? '+' : '-'}${pad(Math.floor(abs / 60))}:${pad(abs % 60)}`;
  return zone ? `${zone} (${offset})` : offset;
};
